import { BaseAuthService } from './base';

export class QQAuth extends BaseAuthService {

  async login() {
    // 实现微信登录逻辑
  }

  async getUserInfo() {
    // 获取用户信息
  }
}
